import { type FC, useMemo } from "react";
import { ContentType, type PeopleType } from "../../../../features/Library/PeopleAssignments/types";
import { type IEmbeddedVideoAssignmentModelItem } from "../../../../features/People/types";
import dateTimeUtils from "../../../../utils/dateTimeUtils";
import { type EmbeddedVideoCardBaseProps } from "../../../cards/EmbeddedVideoCard/types";
import PublishStatusCard from "../../../cards/PublishStatusCard";
import ExpiresCardTemplate from "../../../ExpiresTemplate/ExpiresCardTemplate/ExpiresCardTemplate";
import getCardPriorityIcon from "../../priority/getCardPriorityIcon";

import { RouteNames } from "enums";

import "./peopleEmbeddedVideoCard.scss";

export interface PeopleEmbeddedVideoCardProps extends EmbeddedVideoCardBaseProps<IEmbeddedVideoAssignmentModelItem> {
  peopleType: PeopleType;
  showExpirationDate?: boolean;
  showAdded?: boolean;
  deepLink?: boolean;
}

export const PeopleEmbeddedVideoCard: FC<PeopleEmbeddedVideoCardProps> = (
  props: PeopleEmbeddedVideoCardProps,
): React.ReactElement => {
  const { showExpirationDate, onSelect, item, selected, disabled, peopleType, showAdded, selectable, deepLink } = props;

  const { id, isDraft, dateCreated, expirationDate, priorityLevelId, dueDate } = item;

  const icons = useMemo(
    () => [
      getCardPriorityIcon({
        peopleType,
        contentType: ContentType.EmbeddedVideo,
        priority: priorityLevelId,
        dueDate,
        tooltipClass: "people-embedded-video-priority-tooltip",
        showNone: false,
      }),
    ],
    [dueDate, peopleType, priorityLevelId],
  );

  return (
    <PublishStatusCard
      {...item}
      id={id}
      url={!item.inherited && deepLink ? `/${RouteNames.contentEmbeddedVideos}/${id}` : undefined}
      className="people-embedded-video-card"
      onSelectionChanged={onSelect}
      disablePopupMenu={selected}
      published={!isDraft}
      icons={icons}
      selected={selected}
      disabled={disabled}
      selectable={selectable}
      isHidden={!item.visibility}
    >
      {showExpirationDate && <ExpiresCardTemplate expirationDate={expirationDate} />}
      {showAdded && <div>Added {dateTimeUtils.formatDate(dateCreated)}</div>}
    </PublishStatusCard>
  );
};
